import React from 'react';
import { ThemeProvider } from '@mui/material';

import { tableTheme } from 'core/styles/tableTheme';

import { BaseTable, TableProps } from './BaseTable';

export function Table<TData extends Record<string, any> = Record<string, unknown>>(
  props: TableProps<TData>,
) {
  return (
    <ThemeProvider theme={tableTheme}>
      <BaseTable {...props} />
    </ThemeProvider>
  );
}
